import React from 'react';
import InputField from './InputField';

const DemoView = () => {
  return (
    <div className="p-6 max-w-xl mx-auto bg-white rounded-xl shadow-md border border-blue-100">
      <h2 className="text-xl font-bold text-blue-800 text-center mb-4">詳細入力デモ</h2>

      <InputField
        label="通常時回転数"
        value="664"
        disabled={true}
        tooltipImageSrc="img/normal_spins_sample.png"
        tooltipText="この画像の赤枠部分が「通常時回転数」に該当します。"
      />

      <InputField
        label="チャンス中回転数"
        value="1776"
        disabled={true}
        tooltipImageSrc="img/chance_spins_sample.png"
        tooltipText="この画像の赤枠部分が「チャンス中回転数」に該当します。"
      />

      <InputField
        label="獲得出玉（獲得数の合計）"
        value="35360"
        disabled={true}
        tooltipImageSrc="img/total_output_sample.png"
        tooltipText="この画像の赤枠部分が「獲得出玉（獲得数の合計）」に該当します。"
      />

      <InputField
        label="最終差玉"
        value="25000"
        disabled={true}
        tooltipImageSrc="img/final_difference_sample.png"
        tooltipText="グラフの最終値、赤線の数値が「最終差玉」に該当します。"
      />
      <InputField
        label="持ち玉減少率（例: 10% = 0.1を入力）"
        value="0.1"
        disabled={true}
        tooltipImageSrc="img/decrease_rate_sample.png"
        tooltipText="この画像の赤枠部分が「持ち玉減少率」に該当します。"
      />
      <InputField
        label="1000円あたりの貸し玉数（通常は250）"
        value="250"
        disabled={true}
        tooltipImageSrc="img/balls_per_1000yen_sample.png"
        tooltipText="この画像の赤枠部分が「1000円あたりの貸し玉数」に該当します。"
      />

      <div className="text-center flex justify-center gap-4 mt-4">
        <button className="bg-blue-800 hover:bg-blue-900 text-white font-semibold py-2 px-6 rounded">
          回転率を計算
        </button>

        <button className="bg-blue-100 hover:bg-blue-200 text-blue-800 font-semibold py-2 px-6 rounded">
          クリア
        </button>
      </div>

      <div className="text-center mt-4 text-lg font-semibold">
        回転率: <span className="text-blue-700">16.3 回/K</span>
      </div>
    </div>
  );
};

export default DemoView;
